import React, { useMemo } from "react"
import { BadgeQRFormat } from "sharedTypes/badge"
import { generateQRCodePath } from "../utils/qrCodeGenerator"

type QRCodePlaceholderProps = {
  format: BadgeQRFormat
}

const QRCodePlaceholder = ({
  format,
}: QRCodePlaceholderProps) => {
  // QR codes are always black on white for optimal scanning
  const foregroundColor = "#000000"
  const backgroundColor = "#ffffff"
  // Generate QR code path based on format - memoized for performance
  const qrPath = useMemo(
    () => generateQRCodePath(format),
    [format],
  )

  // Fallback to static placeholder if generation fails
  if (!qrPath) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 370 370" preserveAspectRatio="none">
        <rect width="370" height="370" fill={backgroundColor} />
        <path
          d="M16 16v112h112V16H16zm128 0v32h16V32h16V16h-32zm32 16v16h16V32h-16zm16 16v16h32V16h-16v32h-16zm0 16h-48v16h32v16h-16v16h16v16h16v-16h16v16h-16v16h-16v16h32v16h16V96h-16V80h-16V64zm16 112h-16v16h-16v32h16v32h-32v-16h16v-16h-16v-32h-16v-16h16v16h16v-32h-32v-16H96v16H80v16H64v-16h16v-16H48v16H32v48h16v-16h48v-16h16v-16h16v16h-16v16h16v16h-16v16h32v48h16v16h48v16h-48v-16h-16v32h16v16h-16v16h32v-16h16v16h64v-16h16v16h48v-16h-32v-16h-16v-16h-16v16h-32v16h-16v-16h16v-48h16v-16h-32v-16h16v-48h-16v-16zm48 128v-16h-16v16h16zm32 16h32v-16h-32v16zm32-16h16v-64h-48v-16h-16v16h-16v32h16v-16h16v32h32v16zm-48-80v-16h-32v16h32zm16 0h16v-48h16v16h16v16h16v-32h-16v-16h16v-16h-32v16h-16v-16h-16v16h-16v16h16v48zm-16-48h-16v16h16v-16zm64 32h-16v16h16v-16zm-224 0v-16H96v16h16zm-16 0H48v16h48v-16zm-64 0H16v16h16v-16zm0-48v-16H16v16h16zm112-16h16v-32h-16v32zm96-128v112h112V16H240zM32 32h80v80H32V32zm224 0h80v80h-80V32zM48 48v48h48V48H48zm224 0v48h48V48h-48zm-32 96v16h16v-16h-16zM16 240v112h112V240H16zm16 16h80v80H32v-80zm16 16v48h48v-48H48zm288 48v16h16v-16h-16z"
          fill={foregroundColor}
        />
      </svg>
    )
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <rect width="100" height="100" fill={backgroundColor} />
      <path d={qrPath} fill={foregroundColor} />
    </svg>
  )
}

export default QRCodePlaceholder
